<template>
  <div>
    <p class="result">Итого: {{ getTotal| fractionSizeSpace }}
      {{ makeDeclension(getTotal, "балл", "балла", "баллов") }}</p>
    <p class="balance">Баланс: {{ dealerBalance | fractionSizeSpace }}
      {{ makeDeclension(dealerBalance, "балл", "балла", "баллов") }}</p>
    <p v-if="isEnoughBalance" class="remainder">Остаток: {{ dealerBalance - getTotal | fractionSizeSpace }}
      {{ makeDeclension(dealerBalance - getTotal, "балл", "балла", "баллов") }}</p>
    <p v-if="!isEnoughBalance" class="lacks">Не хватает: {{ Math.abs(dealerBalance - getTotal)| fractionSizeSpace }}
      {{ makeDeclension(dealerBalance - getTotal, "балл", "балла", "баллов") }}</p>
    <div class="form-group mt-4">
      <button
          :disabled="disabledSubmit"
          class="btn btn-default fl-sm"
          @click="createOrder()"
      >
        Оформить заказ
      </button>
    </div>
    <div class="form-group mt-4">
      <label class="consent-checkbox-label">
            <span class="consent-checkbox-input-wrapper">
              <input
                  class="consent-checkbox"
                  type="checkbox"
                  name="consent"
                  :checked="isConsentApproved"
                  @change="(e) => onConsentChange(e)"
              />
            </span>
        <span class="consent-checkbox-text">Согласен с условиями <a :href="consentLink" target="_blank">Политики в отношении обработки персональных данных</a></span>
      </label>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import EntityMixin from "@/mixins/EntityMixin";

export default {
  name: "CartTotals",
  mixins: [EntityMixin],
  computed: {
    ...mapGetters('common', ['makeDeclension']),
    ...mapGetters('cart/dealer', [
      'isEnoughBalance',
      'dealerBalance',
      'isProductOrderCreating',
      'deliveryPhone',
      'deliveryEmail',
      'dealerStocksSale',
      'splitOrder',
      'isConsentApproved',
    ]),
    ...mapGetters('cart', ['items', 'itemsLongTermProduction', 'getTotal']),
    ...mapGetters('builtInParameter', ['closeOrdersDealerByDate']),
    ...mapGetters( 'account', [ 'accountInfo' ] ),
    ...mapGetters('common', [ 'consentLink' ]),
    closePurchaseByDate() {
      if (this.dealerStocksSale.value === '1' && this.isCurrentUserDealer) {
        return false
      }
      return this.closeOrdersDealerByDate !== ''
    },
    checkEmailValid() {
      const regexp= /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z0-9]([a-zA-Z\-0-9]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}))$/;
      return !!this.deliveryEmail.match(regexp)
    },
    checkPhoneValid() {
      return this.deliveryPhone.length >= 11
    },
    disabledSubmit() {

      // if (+this.accountInfo.dealerUniqueId === 123) {
      //   return !this.isConsentApproved;
      // }
      // if (+this.accountInfo.dealerUniqueId === 789654123) {
      //   return (!this.isEnoughBalance && !this.isConsentApproved) ||
      //       (this.isProductOrderCreating && !this.isConsentApproved) ||
      //       (!this.checkEmailValid && !this.isConsentApproved) ||
      //       (!this.checkPhoneValid && !this.isConsentApproved) ||
      //       (!!this.items.length && !!this.itemsLongTermProduction.length && this.splitOrder === null && !this.isConsentApproved)
      // }
      return !this.isEnoughBalance ||
          this.isProductOrderCreating ||
          !this.checkEmailValid ||
          !this.checkPhoneValid ||
          this.closePurchaseByDate ||
          (!!this.items.length && !!this.itemsLongTermProduction.length && this.splitOrder === null) ||
          !this.isConsentApproved
    }
  },
  methods: {
    ...mapMutations('cart/dealer', [ 'SET_CONSENT_APPROVED' ]),
    ...mapActions('cart/dealer', ['createOrder']),
    onConsentChange(e) {
      this.SET_CONSENT_APPROVED(e.target.checked)
    },
  }
}
</script>

<style lang="sass" scoped>
.lacks
  margin: 17px 0
  color: #e5173f
  line-height: 1.71
  font-family: Futuris
  font-size: 14px
</style>
